// removed by extract-text-webpack-plugin
module.exports = {"jumbo":"src-components-drinks----Header-module---jumbo---3_-8u","content":"src-components-drinks----Header-module---content---281Rh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/drinks/Header.module.css
// module id = 401
// module chunks = 38187647151852